import { render, staticRenderFns } from "./vue-scrollbar.vue?vue&type=template&id=5de2c5cf&"
import script from "./vue-scrollbar.vue?vue&type=script&lang=js&"
export * from "./vue-scrollbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports